module.exports = __webpack_public_path__ + "img/start.777cdd5c.png";